<template>
    <div class="park">
        <Title chineseTitle="站点概况" englishTitle="The site survey"></Title>
        <div class="parkContent">
            <div v-if="hasTransformer" class="body">
                <div class="progressContainer">
                    <div class="progressTitle">负荷率</div>
                    <div class="progress">
                        <CircleProgress
                            :value="($store.state.MQTTObj[$store.getters.getOverViewDeviceName($store.state.projectId) + 'P'] / ($store.state.receivingCapacity * 500) ).toFixed(2)" />
                    </div>
                    <div class="progressValue">
                        {{($store.state.MQTTObj[$store.getters.getOverViewDeviceName($store.state.projectId) + 'P'] / ($store.state.receivingCapacity * 5)).toFixed(2) + "%"}}
                    </div>
                    <div class="progressText">{{'受电容量: ' + $store.state.receivingCapacity + 'kVA'}}</div>
                </div>
            </div>
            <div v-if="hasTransformer" class="body">
                <Item title="变压器温度" data="--" unit="" />
            </div>
            <div v-if="!hasTransformer" class="body">
                <Item title="进线负荷"
                    :data="isNaN($store.state.MQTTObj[$store.getters.getDeviceName(areaId) + 'P'] / 1000) ? '--' :  ($store.state.MQTTObj[$store.getters.getDeviceName(areaId) + 'P'] / 1000) "
                    unit="kVA" />
            </div>
            <div v-if="!hasTransformer" class="body">
                <Item title="进线温度"
                    :data="$store.state.MQTTObj[$store.getters.getDeviceName(areaId) + 'Temperature'] || '--'"
                    unit="℃" />
            </div>
            <div class="body">
                <div class="itemContainer">
                    <div class="dataItem">
                        <div class="dataItem_title">设备数量</div>
                        <div class="dataItem_data">{{deviceNum}}</div>
                    </div>
                    <div class="line"></div>
                    <div class="dataItem">
                        <div class="dataItem_title">遥控装置状态</div>
                        <div class="dataItem_data">
                            {{$store.state.CloseAndOpen[0] + '/' + ($store.state.CloseAndOpen[0] + $store.state.CloseAndOpen[1])}}
                        </div>
                    </div>
                    <div class="line"></div>
                    <div class="dataItem">
                        <div class="dataItem_title">电压等级</div>
                        <div class="dataItem_data">{{$store.state.voltageClass + 'kV'}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Title from "@/components/Title.vue";
    import Item from "@/components/Item";
    import CircleProgress from "@/components/CircleProgress";
    import {
        GetCurrentPowerInfo,
        GetAlarmList,
        GetCloseAndOpenNum,
        GetDeviceClassNum,
    } from "@/components/Request";

    export default {
        name: "SiteOverView",
        components: {
            Title,
            Item,
            CircleProgress
        },
        props: ["areaId"],
        data() {
            return {
                hasTransformer: false,
                timer: null,
                deviceNum: 0,
            }
        },
        created() {
            this.areaId == 3 ? this.transformer = true : this.transformer = false
            this.getDeviceNum()
            this.getCloseAndOpenNum()
            this.timer = (() => {
                this.getCloseAndOpenNum();
            }, 3 * 1000);
        },
        watch: {
            areaId(newVal, oldVal) {
                this.timer && clearInterval(timer)
                this.timer && (this.timer = null)
                this.getCloseAndOpenNum()
                this.timer = (() => {
                    this.getCloseAndOpenNum();
                }, 3 * 1000);
            }
        },
        methods: {
            getCloseAndOpenNum() {
                GetCloseAndOpenNum({
                    areaId: this.areaId,
                }).then(({
                    data
                }) => {
                    this.$store.commit("set_val", {
                        CloseAndOpen: data.data.result,
                    });
                }).catch(err => {
                    console.log(err)
                })
            },
            // 获取当前区域电柜数量和是否有变压器
            getDeviceNum() {
                GetDeviceClassNum({
                    areaId: this.areaId,
                }).then(({
                    data
                }) => {
                    let num = 0
                    data.data.result.map((item, index) => {
                        item.num && (num += item.num)
                    })
                    this.hasTransformer = data.data.result.find(item => item.type == '变压设备')
                    this.deviceNum = num
                }).catch(err => {
                    console.log(err)
                })
            }
        },
    };
</script>

<style lang="less" scoped>
    .progressContainer {
        width: 1960/192vw;
        height: 1500/108vh;
        background: #030d18;
        opacity: 0.75;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
    }

    .progressTitle {
        font-size: 18px;
        font-weight: 400;
        color: #e6f8ff;
        opacity: 0.7;
    }

    .progress {
        width: 1200/192vw;
        height: 640/108vh;
        background: #030d18;
    }

    .progressValue {
        margin-top: -30px;
        font-size: 24px;
        font-weight: bold;
        color: #ffffff;
    }

    .progressText {
        font-size: 14px;
        font-weight: 400;
        color: #e6f3fd;
        opacity: 0.7;
    }

    .itemContainer {
        width: 4000/192vw;
        height: 1500/108vh;
        background: #030d18;
        opacity: 0.75;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
    }

    .dataItem {
        height: 1000/108vh;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
    }

    .line {
        width: 10/192vw;
        height: 900/108vh;
        background: #ffffff;
        opacity: 0.15;
    }

    .dataItem_title {
        font-size: 160/192vw;
        color: #e6f8ff;
    }

    .dataItem_data {
        font-size: 240/192vw;
        color: #e6f3fd;
    }

    .park {
        position: fixed;
        top: 2500/108vh;
        left: 160/192vw;

        .parkContent {
            margin-left: 112/192vw;
            width: 4080/192vw;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;

            .body {
                margin-left: 80/192vw;
                margin-top: 80/108vh;
                overflow: hidden;
            }
        }
    }
</style>